import * as echarts from 'echarts'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'

export type SmoothLineChartData = {
  [key: string]: string
}

type SmoothLineChartProps = {
  title?: string
  data: any[] | undefined
  height?: number | string
  width?: number | string
}

const toCssSize = (size?: number | string) =>
  typeof size === 'number' ? `${size}px` : size || '100%'

const SmoothLineChartWrapper = styled.div<Partial<SmoothLineChartProps>>`
  width: ${(props) => toCssSize(props.width)};
  height: ${(props) => toCssSize(props.height)};
  min-height: 0;
`

export const PVLineChart = <T extends SmoothLineChartProps>(
  smoothLineChartProps: T
): React.ReactElement => {
  const chartDom = useRef<HTMLDivElement>(null)
  const { title, data, height = '100%', width = '100%' } = smoothLineChartProps

  useEffect(() => {
    if (chartDom.current) {
      const chartInstance = echarts.init(chartDom.current)
      chartInstance.setOption({
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'time',
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: title,
            data: data,
            type: 'line',
            smooth: true,
          },
        ],
      })

      const resizeObserver = new ResizeObserver(() => {
        chartInstance.resize()
      })
      resizeObserver.observe(chartDom.current)

      return () => {
        resizeObserver.disconnect()
        chartInstance.dispose()
      }
    }
  }, [title, data])
  return (
    <SmoothLineChartWrapper width={width} height={height}>
      <div
        id="smooth-line-chart"
        ref={chartDom}
        style={{ width: width, height: height }}
      />
    </SmoothLineChartWrapper>
  )
}
